import { Box, Button, SxProps, Theme } from '@mui/material';

export const viewSwitchButtonClass = 'Kheops-viewSwitch-button';

const SwitchButtonStyle: SxProps<Theme> = {
  px: 0,
  color: 'onSurface.main',
};

const SelectedViewButtonStyle: SxProps<Theme> = {
  ...SwitchButtonStyle,
  backgroundColor: 'tertiary.main',
  color: 'onTertiary.main',
  '&:hover': {
    backgroundColor: 'tertiary.main',
  },
  '&:focus': {
    backgroundColor: 'tertiary.main',
  },
  '&:focus:not(:focus-visible)': {
    backgroundColor: 'tertiary.main',
  },
  '&:active': {
    backgroundColor: 'tertiary.main',
  },
};

const NonSelectedViewButtonStyle: SxProps<Theme> = {
  ...SwitchButtonStyle,
  backgroundColor: 'surface.main',
  color: 'onSurface.main',
  '&:hover': {
    backgroundColor: 'surfaceContainerLow.main',
  },
  '&:focus': {
    backgroundColor: 'surfaceContainerLow.main',
  },
  '&:focus:not(:focus-visible)': {
    backgroundColor: 'surfaceContainerLow.main',
  },
  '&:active': {
    backgroundColor: 'surfaceContainerLow.main',
  },
};

interface ViewSwitchProps {
  value: string;
  firstViewValue: string;
  secondViewValue: string;
  firstViewValueLabel: string;
  secondViewValueLabel: string;
  onChange: (value: string) => void;
}

export default function ViewSwitch({
  value,
  firstViewValue,
  secondViewValue,
  firstViewValueLabel,
  secondViewValueLabel,
  onChange,
}: ViewSwitchProps): React.JSX.Element {
  const getButtonStyle = (optionValue: string): SxProps<Theme> => {
    return value === optionValue ? SelectedViewButtonStyle : NonSelectedViewButtonStyle;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        border: '1px solid',
        borderColor: 'outline.main',
        borderRadius: 10,
      }}
    >
      <Box sx={{ height: 48, display: 'flex', alignSelf: 'start' }}>
        <Button
          variant="contained"
          className={viewSwitchButtonClass}
          sx={getButtonStyle(firstViewValue)}
          onClick={() => onChange(firstViewValue)}
        >
          {firstViewValueLabel}
        </Button>
        <Button
          variant="contained"
          className={viewSwitchButtonClass}
          sx={getButtonStyle(secondViewValue)}
          onClick={() => onChange(secondViewValue)}
        >
          {secondViewValueLabel}
        </Button>
      </Box>
    </Box>
  );
}
